var React = require('react');

function AllInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}.cls-2{fill:none;}")),React.createElement("path",{"className":"cls-1","d":"M18.06,28.09A10.12,10.12,0,1,1,28.18,18,10.13,10.13,0,0,1,18.06,28.09Zm0-18.82a8.57,8.57,0,0,0-3.28.65,8.71,8.71,0,1,0,6.57,0A8.58,8.58,0,0,0,18.06,9.27Z","key":1}),React.createElement("polygon",{"className":"cls-1","points":"16.82 21.21 13.17 17.57 14.12 16.62 16.82 19.32 22.01 14.13 22.96 15.07 16.82 21.21","key":2}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":3}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":4})]);
}

AllInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = AllInline;

AllInline.default = AllInline;
